// src/components/AdminLayout/AdminLayout.jsx
import React from 'react';
import AdminSidebar from '../AdminSidebar/AdminSidebar'; // Asegúrate de que la ruta sea correcta
import './AdminLayout.css'; // Crearemos este CSS ahora mismo

const AdminLayout = ({ children, isUnderMaintenance, toggleMaintenanceMode }) => {
  return (
    <div className="admin-layout">
      <AdminSidebar 
        isUnderMaintenance={isUnderMaintenance}
        toggleMaintenanceMode={toggleMaintenanceMode}
      />
      <div className="admin-main-content">
        {children} {/* Aquí se renderizarán los componentes hijos (Dashboard, Users, etc.) */}
      </div>
    </div>
  );
};

export default AdminLayout;